import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { SideOverlayRef } from '../side-overlay-ref';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { MatToolbar } from '@angular/material/toolbar';

@Component({
  selector: 'oo-side-overlay-wrapper',
  templateUrl: './side-overlay-wrapper.component.html',
  styleUrls: ['./side-overlay-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatToolbar, MatIconButton, MatIcon],
})
export class SideOverlayWrapperComponent {
  title = input('');
  private readonly sideOverlayRef = inject(SideOverlayRef);

  close(): void {
    this.sideOverlayRef.close();
  }
}
